import React from 'react';
import _ from 'lodash';

import component, {navigateTo} from '../component';
import Api from '../../api';
import {CursorInput} from '../Form';
import TopBanner from '../TopBanner';


export default component('SignIn', function({data}) {
  async function signIn(e) {
    e.preventDefault();
    const authData = {
      nickname: data.getIn(['signInForm', 'nickname']),
      password: data.getIn(['signInForm', 'password'])
    };
    let response = await Api.signin(authData);
    if (response.data) {
      data.setIn(['user'], response.data);
      navigateTo('/');
    }
  }

  const buttonDisabled = _.isEmpty(data.getIn(['signInForm', 'nickname']))
                      || _.isEmpty(data.getIn(['signInForm', 'password']));

  return (
    <div className='SignIn'>
      <TopBanner size='tiny' />
      <form onSubmit={signIn}>
        <CursorInput value={data.cursor(['signInForm', 'nickname'])} />
        <CursorInput value={data.cursor(['signInForm', 'password'])} />
        <input type='submit' disabled={buttonDisabled} value='sign in' />
      </form>
    </div>
  );
});



// WEBPACK FOOTER //
// ./src/components/pages/SignIn.js